import React, {useState} from 'react';
import {Modal} from "react-bootstrap";
import Add from "./components/Add";

const ConnectDomainModal = ({ show, handleNegative, domains = [], onAddSuccess, onFail }) => {
  return <Modal
    show={show}
    onHide={handleNegative}
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <Add
      domains={domains}
      onSuccess={onAddSuccess}
      onFail={onFail}
    />
  </Modal>
}

export default ConnectDomainModal;